import { render, staticRenderFns } from "./MandellsTextInput.vue?vue&type=template&id=f0c51aae&scoped=true"
import script from "./MandellsTextInput.vue?vue&type=script&lang=ts"
export * from "./MandellsTextInput.vue?vue&type=script&lang=ts"
import style0 from "./MandellsTextInput.vue?vue&type=style&index=0&id=f0c51aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c51aae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
